import { loadScript } from '@fastcampus/browser-util';
import { events as gtag } from './gtag';
import { events as gAds } from './g-ads';
import { events as gAdsDynamic } from './g-ad-dynamic';

/**
 * Google Analytics(GA) & Conversion(Ad-Words) using GTM Universal Tracker
 *
 * @see www/view/_partials/_tracker_google.html
 * @see https://developers.google.com/gtagjs/reference/api
 * @see https://support.google.com/google-ads/answer/6095821
 */

export class GoogleTracker {
  static create(opts, context) {
    return new GoogleTracker(opts, context);
  }

  constructor({ id, conversion, userId, optimize }, context) {
    this.name = 'gtag';
    this.id = id;
    this.userId = userId;
    this.conversion = conversion;
    this.optimize = optimize;
    this.gtagEventSet = {};
    this.gAdsEventSet = {};
    this.gAdDynamicEventSet = {};
    if (conversion) {
    }

    context.dataLayer = context.dataLayer || [];
    context.gtag = function () {
      context.dataLayer.push(arguments);
    };
    context.gtag('js', new Date());
    context.gtag('config', this.id, {
      custom_map: {
        dimension1: 'user_id',
        dimension2: 'coupon_ids',
        dimension3: 'format_id',
        dimension4: 'category_id',
        dimension5: 'format_category_id',
        dimension6: 'course_ids',
        dimension7: 'origin_course_ids',
        dimension8: 'banner_id',
        dimension9: 'curation_id',
        dimension10: 'hashtag',
        dimension11: 'customer_id',
        dimension12: 'slug',
        dimension13: 'edu_pid',
        dimension14: 'edu_pagetype',
        dimension15: 'edu_totalvalue',
      },
      user_id: this.userId,
      optimize_id: this.optimize,
    });

    if (this.id) {
      loadScript(`//www.googletagmanager.com/gtag/js?id=${this.id}`)
        .then(() => {})
        .catch((err) => console.error('install err!', err));
    }

    // optimize_id가 gtag에 묶여 있어서 일단 분리하지 않음
    if (this.optimize) {
      loadScript(`//www.googleoptimize.com/optimize.js?id=${this.optimize}`)
        .then(() => {})
        .catch((err) => console.error('install optimize err!', err));
    }

    // 스크립트 로딩 전에도 이벤트 큐잉! -> connect!

    // gtag. GA 기본 트래커
    this.gtag = context.gtag;
    //  gtag의 함수세트
    this.gtagEventSet = gtag({
      tracker: this.gtag,
      condition: { userId: this.userId, optimizeId: this.optimize, id: this.id },
    });

    if (this.conversion) {
      // gAds. gtag를 사용하는 gAds용 트래커
      this.gAds = ({ label }) => {
        this.gtag('event', 'conversion', {
          send_to: this.conversion + '/' + label,
        });
      };
      // gAds의 함수세트
      this.gAdsEventSet = gAds({ tracker: this.gAds, condition: { userId: this.userId } });

      // gAdsDynamic. gAds의 능동광고 서비스를 이용하기 위한 트래커
      this.gAdsDynamic = ({ event, data }) => {
        if (this.conversion) {
          this.gtag('event', event, {
            send_to: this.conversion,
            ...data,
          });
        }
      };
      // gAdDynamic의 함수세트
      this.gAdDynamicEventSet = gAdsDynamic({ tracker: this.gAdsDynamic, condition: { userId: this.userId } });
    }

    this.ready = true;
  }

  track(event, data) {
    if (!this.ready) {
      if (process.env['NODE_ENV'] !== 'prod') console.error('**ignore** not ready!', event, data);
    }

    if (this.gtagEventSet[event]) this.gtagEventSet[event](data);
    if (this.gAdsEventSet[event]) this.gAdsEventSet[event](data);
    if (this.gAdDynamicEventSet[event]) this.gAdDynamicEventSet[event](data);
  }
}
